import LegacyAvatar from './LegacyAvatar';
export default LegacyAvatar;
